import { Component, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute  } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AdminsService } from 'src/app/_services/admins/admins.service';
import { ApartmentService } from 'src/app/_services/apartments/apartment.service';

@Component({
  selector: 'app-handover-flow',
  templateUrl: './handover-flow.component.html',
  styleUrls: ['./handover-flow.component.scss']
})
export class HandoverFlowComponent {
      home: MenuItem | undefined;
  @ViewChild('closebutton') closebutton: any;

  showSide: string = '';
  products!: Array<object>;
  selectedProducts: Array<object> = [];
  headerData: Array<any> = [];
  subscriptions:Subscription[] = [];
  loading: boolean = true;
  monthButton  : boolean= true;
  weekButton  : boolean= false;
  userId:any;
 
  listDropDown: Array<object> = [{ name: 'All  ' },
    { name: 'Today' },
    { name: 'Last Week' },
    { name: 'This month' },
    { name: 'This year' },
  ];
private routeSubscription!:Subscription;
 
private storageRemoved = false;
  constructor(
    private apartmentService: ApartmentService,
    public _adminservices: AdminsService,
    private messageService: MessageService,
    public router: Router,
    private _ActivatedRoute:ActivatedRoute
  ) {
    this.routeSubscription=this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        // if (!event.url.startsWith('/users/app-edite-user-details/')){
        //   console.log("Navigating away from /user-details. Clearing localStorage...");
        //   localStorage.removeItem('pageNoUsers');
        // }
 ///////////////////////////////////////////////////////////////
        //  let currentRoute = event.urlAfterRedirects.replace(/^#/, '');
 
        //  if (!currentRoute.startsWith('/users/app-edite-user-details/')) {
        //    console.log("Navigating away from /users/app-edite-user-details/:id. Clearing localStorage...");
        //    localStorage.removeItem('pageNoUsers');  
        //  }
        //  if (!currentRoute.startsWith('/users')) {
        //   console.log("Navigating away from /users. Clearing localStorage...");
        //   localStorage.removeItem('pageNoUsers');  
        // }
           
        let currentRoute = event.urlAfterRedirects.replace(/^#/, '');

        console.log("🔍 Current Route:", currentRoute);
        console.log("🚀 Checking if storage should be removed...");

        // ✅ Keep LocalStorage when on "/users" or "/users/app-edite-user-details/:id"
        if (
          currentRoute === '/users' || 
          /^\/users\/app-edite-user-details\/[a-zA-Z0-9-]+$/.test(currentRoute)
        ) {
          console.log("✅ Allowed route detected. Keeping LocalStorage.");
          this.storageRemoved = false; // Reset when returning to an allowed route
        } 
        // ❌ Remove LocalStorage only the first time leaving the allowed routes
        else if (!this.storageRemoved) {
          console.log("🚨 Leaving allowed routes for the first time. Removing LocalStorage...");
          localStorage.removeItem('pageNoUsers');
          this.storageRemoved = true; // Prevent removing again when returning
        } else {
          console.log("🔵 Already left allowed route before, no need to remove again.");
        }
      }
    })
  }
  currentPage: number = 0;
  @ViewChild('dt2', { static: false }) dt2?: any;
  tableReady = false;

  onPageChange(event: any) {
    this.currentPage = event.first;
    console.log(this.currentPage)
    localStorage.setItem('userPage', this.currentPage.toString());
  }

apt_UUID:any;
  ngOnInit() {
    this.apt_UUID = this._ActivatedRoute.snapshot.paramMap.get('id');
    const savedPage = localStorage.getItem('userPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage)

    this.home = { icon: 'pi pi-home', routerLink: ['/dashboard'] };

    // this.getAllTenants();
    this.checkRole();
    if(localStorage.getItem('pageNoUsers')){
      let number=Number(localStorage.getItem('pageNoUsers'))
      let numberF=Number(localStorage.getItem('first'))

      let numberR=Number(localStorage.getItem('rows'))

      this.pageNumber=number
      this.first=numberF
      this.rows=numberR
    // this.getAllTenants();
    this.getAllHandover()

      
    }else{
    // this.getAllTenants();
   this.getAllHandover()

    }

  
  }


handovers:any[]=[]
  getAllHandover(){
    this.apartmentService.getAllHandovers(1,20000,this.apt_UUID).subscribe({
      next: (res) =>{
         console.log('Handover:',res)
         this.Tenants=res.data.map((item:any) =>({
             ...item,
             handoverId: item.handover_Code,
             workerName:item.worker_Name,
             avatar:item.worker_Profile_Image,

             
         }))
        this.numberTenants= res.totalRecords

      },
      error: (err) =>{
        console.error('Failed to fetch handover', err)
      }
    })
  }
  TantsRole: any;
  is_Super: any;
  checkRole() {
    const data = localStorage.getItem('user');
    if (data !== null) {
      let parsedData = JSON.parse(data);
      this.is_Super = parsedData.is_Super;
      if (parsedData.is_Super == false) {
        for (let i = 0; i < parsedData.permissions.length; i++) {
          if (parsedData.permissions[i].page_Name == 'Users') {
            this.TantsRole = parsedData.permissions[i];
          }
        }
        if (this.TantsRole.p_View == false && this.is_Super == false) {
          this.gotopage();
        }
      }
    }
  }
  gotopage() {
    let url: string = 'unlegal';
    this.router.navigateByUrl(url);
  }
  /**
   * selectedfromDropDown
   * @param $event string
   * @returns void
   */
    selectedfromDropDown(value: any) {
    this.Date = value.name;
    
  }

    FilterButtons(value:any){
    this.Date=value;
    if(this.Date == 'This Month'){
      this.monthButton = true;
      this.weekButton = false
    }else{
      this.monthButton = false;
      this.weekButton = true;
    }
    
  }
  /**
   * addItem
   * @param value string
   * @returns void
   */
  addItem(value: string): void {
    this.showSide = value;
  }

  statusTenant: any = '';
  pageNumber = 1;
  pagesize = 10;
  totalofPages = 0;
  disablenext = false;
  disableperv = false;
  first: number = 1;
  rows: number = 10;

  Tenants:any[] = [];
  numberTenants = 0;
  totalRecords = 0;
  Date: any = 'All';
  

  
  
  
  
  
 
  detailperson(event: any, id: any): void {
  
  }


  display = 'none';
  model1: Boolean = false;
  model2: Boolean = false;
  model3: Boolean = false;
  deleteModal(id: any) {
    this.display = 'block';
    this.display = 'flex';
    this.model1 = true;
    this.model2 = false;
    this.model3 = false;
    this.userId = id;
  }
  SuspendModal(id: any) {
    this.display = 'block';
    this.display = 'flex';
    this.model2 = true;
    this.model1 = false;
    this.model3 = false;
    this.userId = id;
  }
  UnSuspendModal(id: any) {
    this.display = 'block';
    this.display = 'flex';
    this.model3 = true;
    this.model1 = false;
    this.model2 = false;
    this.userId = id;
  }
  onCloseHandled() {
    this.display = 'none';
  }

  navigateToAddHandover(){
    this.router.navigateByUrl(`apartments/add-new-handover/${this.apt_UUID}`);

  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    } 

    for(let i=0;i<this.subscriptions.length;i++)
    this.subscriptions[i].unsubscribe();
  }
 globalFilter: string = '';

}
